module.exports = __webpack_public_path__ + "img/nandu-night-scene-v2.0171e14b.png";